import { useState } from 'react';
import { navigate } from 'gatsby';
import Validation from '../../helpers/validation';

interface ErrorsType {
  emailError?: string;
  phoneError?: string;
  messageError?: string;
}

const useForm = () => {
  const CHAT_BOT_TOKEN = process.env.CHAT_BOT_TOKEN;
  const CHAT_ID = process.env.CHAT_ID;

  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [showTroubleModal, setShowTroubleModal] =
    useState(false);
  const [showSucceessModal, setShowSucceessModal] =
    useState(false);
  const [err, setErr] = useState<ErrorsType>({});

  const {
    emailValidation,
    phoneValidation,
    messageValidation,
  } = Validation();

  const changeEmail = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setEmail(e.target.value);
  };

  const changePhone = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPhone(e.target.value);
  };

  const changeMessage = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setMessage(e.target.value);
  };

  const check = async () => {
    const emailError = emailValidation(email);
    const phoneError = phoneValidation(phone);
    const messageError = messageValidation(message);
    if (!!emailError || !!phoneError || !!messageError) {
      setErr({
        emailError,
        phoneError,
        messageError,
      });
      return true;
    } else {
      setErr({});
      return false;
    }
  };

  const textToSend = `<b>емейл</b>: ${email},%0A<b>телефон</b>: ${phone},%0A<b>сообщение</b>: ${message}`;

  const handleSuccess = () => {
    setShowSucceessModal(true);
    setEmail('');
    setPhone('');
    setMessage('');
    setErr({});
  };

  const closeSuccess = ()=>setShowSucceessModal(false);

  const handleTrouble = () => {
    setShowTroubleModal(true);
    setTimeout(() => setShowTroubleModal(false), 3000);
  };

  const send = async (e:any) => {
    e.preventDefault();
    const flag = await check();
    if (flag) {
      return;
    } else {
      await fetch(
        `https://api.telegram.org/bot${CHAT_BOT_TOKEN}/sendMessage?chat_id=${CHAT_ID}&parse_mode=html&text=${textToSend}`
      )
        .then((res) => res.json())
        .then((result) => {
          if (result?.ok) {
            handleSuccess();
          } else {
            handleTrouble();
          }
        })
        .catch((err) => {
          handleTrouble();
        });
    }
  };

  return {
    send,
    email,
    changeEmail,
    emailError: err.emailError,
    phone,
    changePhone,
    phoneError: err.phoneError,
    message,
    changeMessage,
    messageError: err.messageError,
    showTroubleModal,
    showSucceessModal,
    closeSuccess
  };
};

export default useForm;
